import React, { useState } from "react";
import { UnlockIcon, TriangleDownIcon, EditIcon } from '@chakra-ui/icons';
import {Heading,Box, Container, Button, Image, Popover, Stack, Input} from "@chakra-ui/react";
import LoginModal from "./LoginModal";
import RegisterModal from "./RegisterModal";
import {Link} from "react-router-dom";
import {BsSearch} from 'react-icons/bs';
import "./Navbar.css";

const Navbar = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalRegister, setIsModalRegister] = useState(false);
    
    const handleLogin = () => {
       setIsModalVisible(true);
    }

    const handleRegister = () => {
        setIsModalRegister(true);
    }

    return(
        <>
        <Container maxW='98%'>
            <Button fontSize='10px' rightIcon={<TriangleDownIcon />} colorScheme='teal' variant='ghost' color='black' >
                <u>UNITED STATES</u>
            </Button>
            <Button fontSize='10px' colorScheme='teal' variant='ghost' color='black' >
                <u>CUSTOMER CARE</u>
            </Button>
            <Button fontSize='10px' colorScheme='white' variant='ghost'>FREE STANDARD SHIPPING ON ORDERS OVER $200</Button>
            <Button fontSize='10px' leftIcon={<EditIcon />} colorScheme='teal' variant='ghost' color='black' onClick={() => handleRegister()}>
               <u>REGISTER</u>
            </Button>
            <Button fontSize='10px' leftIcon={<UnlockIcon />} colorScheme='teal' variant='ghost' color='black' onClick={() => handleLogin()}>
               <u>LOGIN</u>
            </Button> 
            <hr></hr>    
        </Container>

        <div className="navbar_links" >
            <Box className="navbar_links_button" >
                <Button colorScheme='teal' variant='ghost'color='#3333333'>
                <Link to="/women">WOMEN</Link>
                </Button>
                <Button colorScheme='teal' variant='ghost'color='#3333333'>
                <Link to="/men">MEN</Link>
                </Button>
                <Button colorScheme='teal' variant='ghost'color='#3333333'>
                    KIDS
                </Button>
                     
                <Button colorScheme='teal' variant='ghost'color='#3333333'>
                DESIGN+ART
                </Button>
            </Box>
            <div className="site_logo">
                <Link to="/"><img className="site_logo_1" src="https://www.yoox.com/media/yoox16/header/yoox-logo-p.svg" alt="logo" /></Link>

            </div>
            <Box className="navbar_links_icon">
                <BsSearch />
                <h2>Faveroute</h2>
                <h2>Cart</h2>
            </Box> 
        </div>

        <Container  maxW='100%' bg='#333' height='40px'>
            <Box id="container">
             <p>NEW ARRIVALS </p>
             <p>DESIGNERS </p>
             <p> CLOTHING </p>
             <p> SHOES </p>
             <p>ACCESSORIES & BAGS </p>
             <p>8 BY YOOX</p>
             <p>YOOXYGEN </p>
             <p>COLLABORATIONS </p>
             <p> SALE </p>
            </Box>
            
        </Container>
        <LoginModal isOpen={isModalVisible} setIsOpen={setIsModalVisible} />
        <RegisterModal isRegisterOpen={isModalRegister} setIsRegisterOpen={setIsModalRegister} />
        </>
    )
}

export default Navbar;
